import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

import { $versioningDialog } from "../../internal/versioning-dialog";

/**
 * Hook to control the versioning dialog state.
 * DocumentId should be obtained from the route or passed as a prop to the dialog.
 */
export const useVersioningDialog = () => {
	const state = useAtomValue($versioningDialog);
	const setState = useSetAtom($versioningDialog);

	const openBranches = useCallback(
		(opts?: {
			autoOpenHead?: boolean;
			autoOpenPublish?: boolean;
			autoOpenPublishSettings?: boolean;
		}) => {
			setState({
				view: "branches",
				autoOpenHead: opts?.autoOpenHead,
				autoOpenPublish: opts?.autoOpenPublish,
				autoOpenPublishSettings: opts?.autoOpenPublishSettings,
			});
		},
		[setState]
	);

	const openSettings = useCallback(() => {
		setState({ view: "settings" });
	}, [setState]);

	const close = useCallback(() => {
		setState(null);
	}, [setState]);

	return {
		isOpen: state !== null,
		view: state?.view ?? "settings",
		autoOpenHead: state?.autoOpenHead ?? false,
		autoOpenPublish: state?.autoOpenPublish ?? false,
		autoOpenPublishSettings: state?.autoOpenPublishSettings ?? false,
		openBranches,
		openSettings,
		close,
	};
};
